const LiferayApi = {
    get: (url, callback, errorHandler) => {
        callService(url, 'GET', null, callback, errorHandler);
    },
    put: (url, data, callback, errorHandler) => {
        callService(url, 'PUT', data, callback, errorHandler);
    },
    putWithoutData: (url, callback, errorHandler) => {
        callService(url, 'PUT', null, errorHandler);
    },
    post: (url, data, callback, errorHandler) => {
        callService(url, 'POST', data, callback, errorHandler);
    },

    delete: (url, data, callback, errorHandler) => {
        callService(url, 'DELETE', data, callback, errorHandler);
    },

    test: () => {
        console.debug('OK')
    }
}

const callService = (url, method, data, callback, errorHandler) => {
    try {
        if (Liferay.ThemeDisplay.isSignedIn()) {
            const config = {
                method: method,
                timeout: 5000,
                dataType: "json",
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json',
                    'x-csrf-token': Liferay.authToken
                }
            };
            if (data){
                config.body = JSON.stringify(data);
            }
            fetch(url, config)
                .then((response) =>{
                    return response.text()
                })
                .then((data) => {
                    return (data ? JSON.parse(data) : {})
                }).then((data) => {
                if (callback) callback(data);
            })
                .catch((error) => {
                    console.error(error);
                    if (error.status === 403){
                        reloadOnce();
                    }else{
                        if (errorHandler){
                            errorHandler(error)
                        }
                    }
                });
        }
    } catch (error) {
        console.error(error);
    }
}

function reloadOnce() {
    console.debug('reloadOnce');
    if (window.localStorage) {
        if (!localStorage.getItem('reloadOnce')) {
            localStorage['reloadOnce'] = true;
            window.location.reload();
        } else {
            localStorage.removeItem('reloadOnce');
        }
    }
}

export default LiferayApi;